<template>
  <tr>
    <td :class="'text-center ' + additionalClasses">{{ helpForm }}</td>
    <td class="text-center">
      <b>{{ code }}</b>
    </td>
  </tr>
</template>

<script>
// @vuese
// Prosty wiersz do tabeli
// @group staticComponents
export default {
  props: {
    // Rodzaj pomocy
    helpForm: { type: String, default: '' },

    // Kod
    code: { type: String, default: '' },

    // Rozszerzenie klasy
    additionalClasses: { type: String, default: null }
  }
};
</script>
